import { css } from 'styled-components';

export const printUnclip = css`
	@media print {
		display: block !important;
		height: auto !important;
		min-height: 0 !important;
		overflow: visible !important;
		flex: none !important;
	}
`;
